<template>
  <modal>
    <template v-slot:header>
      <h5 class="modal-title">{{$t('form.email-verification.title')}}</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
        <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
      </button>
    </template>

    <template v-slot:body>
      <div class="modal-body__registration">
        <p>{{$t('form.email-verification.confirmation-link-was-sent-to-your-email')}}</p>
        <p>{{$t('form.email-verification.open-received-link-for-confirmation')}}</p>
      </div>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--red gui-btn--ep" type="button" @click="$emit('close')" v-t="'buttons.next'"></button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/widgets/modal'

  export default {
    data: () => ({
      code: undefined,
    }),

    components: {
      Modal
    }
  }
</script>

<style scoped>

</style>
